import { routeToSpecificScope } from "../../helpers/helpersts";
import { SERVER } from "../../config/server.config";
import { requestData } from "../../config/services/datasets";
import {
  addLoadingFlag,
  changeMessageLoading,
  subLoadingFlag,
} from "./loading";
import { DEFAULT_INTENSITIES } from "../../config/constants";
import { Dispatch } from "redux";
import { RootState } from "../reducers";
import { AppThunk } from "../../config/commonTypes";
import {
  IntensitiesAction,
  IntensitiesState,
  Intensity,
  IntensityUI,
  TeamIntensities,
} from "store/types/intensities";

export const updateIntensities = (data: IntensitiesState["teamsById"]) => {
  return {
    type: IntensitiesAction.UPDATE_INTENSITIES,
    data,
  };
};

const normalizeTeams = (
  data: TeamIntensities[]
): Record<string, IntensityUI[]> => {
  return Object.fromEntries(
    data.map((team) => [
      team.teamId,
      team.intensities.map((intensity) => ({
        ...intensity,
        id: crypto.randomUUID(), //UI only
        isEditable: !DEFAULT_INTENSITIES.has(intensity.name),
      })),
    ])
  );
};

export const getIntensities = (
  teamId: string,
  forcedScope?: string
) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const path = getState().router.location.pathname;
    const scope = forcedScope || routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const results = await requestData(SERVER.INTENSITIES(teamId));
    if (results && results.length && results[0]) {
      const parsed: TeamIntensities[] = JSON.parse(results[0]);
      const normalizedIntensities = normalizeTeams(parsed);
      dispatch(updateIntensities(normalizedIntensities));
    } else {
      dispatch(updateIntensities({}));
      dispatch(
        changeMessageLoading(scope, "No data matches your specified criteria")
      );
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const updateCustomIntensities = (
  intensities: Intensity[],
  teamId: string
): AppThunk => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    const bodyIntensities = intensities;
    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(bodyIntensities),
    };
    dispatch(addLoadingFlag(scope));
    const response = await requestData(SERVER.INTENSITIES(teamId), request);
    if (response) {
      dispatch(getIntensities(teamId));
    }
    dispatch(subLoadingFlag(scope));
  };
};
